function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var AllBlocksTemplate = require('./all-blocks.template');
var _require = require('../explorer-format'),
  formatBlocksForTeaser = _require.formatBlocksForTeaser;
var _require2 = require('../peer/client'),
  sendExplorerPeerRequest = _require2.sendExplorerPeerRequest;
var PAGE_SIZE = 25;
var AllBlocks = /*#__PURE__*/function () {
  function AllBlocks(app, mod) {
    _classCallCheck(this, AllBlocks);
    this.app = app;
    this.mod = mod;
    this.container = '.explorer-view';
    this.rawBlocks = [];
    this.loading = true;
    this.loadingMore = false;
    this.hasMore = true;
    this.error = null;
    this.scrollHandler = null;
    this.autoRefresh = false;
    this.showForkBlocks = false;
    this.loadToken = 0;
    this.newBlockHash = null;
  }
  return _createClass(AllBlocks, [{
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      this.rawBlocks = [];
      this.loading = true;
      this.loadingMore = false;
      this.hasMore = true;
      this.error = null;
      this.newBlockHash = null;
      this.paint();
      this.loadInitial();
    }
  }, {
    key: "paint",
    value: function paint() {
      var blocks = formatBlocksForTeaser(this.app, this.rawBlocks);
      this.app.browser.replaceElementContentBySelector(AllBlocksTemplate({
        blocks: blocks,
        loading: this.loading,
        loadingMore: this.loadingMore,
        hasMore: this.hasMore,
        error: this.error,
        autoRefresh: this.autoRefresh,
        showForkBlocks: this.showForkBlocks,
        newBlockHash: this.newBlockHash
      }), this.container);
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      document.querySelectorAll('.explorer-all-blocks-feed .explorer-block-card[data-block-hash]').forEach(function (el) {
        var navigate = function navigate(event) {
          var _event$target, _event$target2, _event$preventDefault;
          var blockLink = event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.closest('.explorer-block-card-hash-link[data-block-hash]');
          if (blockLink) {
            event.preventDefault();
            var _hash = blockLink.getAttribute('data-block-hash');
            if (_hash) {
              _this.cleanup();
              _this.mod.renderBlock(_hash, {
                pushState: true,
                animate: true
              });
            }
            return;
          }
          if (event !== null && event !== void 0 && (_event$target2 = event.target) !== null && _event$target2 !== void 0 && _event$target2.closest('.explorer-pubkey-link')) {
            return;
          }
          event === null || event === void 0 || (_event$preventDefault = event.preventDefault) === null || _event$preventDefault === void 0 || _event$preventDefault.call(event);
          var hash = el.getAttribute('data-block-hash');
          if (hash) {
            _this.cleanup();
            _this.mod.renderBlock(hash, {
              pushState: true,
              animate: true
            });
          }
        };
        el.onclick = navigate;
        el.onkeydown = function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            navigate(event);
          }
        };
      });
      var loadMoreBtn = document.querySelector('.explorer-load-more-btn');
      if (loadMoreBtn) {
        loadMoreBtn.onclick = function () {
          return _this.loadMore();
        };
      }
      var autoRefreshCheckbox = document.querySelector('[data-explorer-auto-refresh]');
      if (autoRefreshCheckbox) {
        autoRefreshCheckbox.checked = this.autoRefresh;
        autoRefreshCheckbox.onchange = function () {
          _this.autoRefresh = autoRefreshCheckbox.checked;
        };
      }
      var showForkBlocksCheckbox = document.querySelector('[data-explorer-show-forks]');
      if (showForkBlocksCheckbox) {
        showForkBlocksCheckbox.checked = this.showForkBlocks;
        showForkBlocksCheckbox.onchange = function () {
          _this.showForkBlocks = showForkBlocksCheckbox.checked;
          _this.reload();
        };
      }
      var newBlockRow = document.querySelector('.explorer-block-card--new');
      if (newBlockRow) {
        var animatedHash = newBlockRow.getAttribute('data-block-hash');
        newBlockRow.addEventListener('animationend', function () {
          newBlockRow.classList.remove('explorer-block-card--new');
          if (_this.newBlockHash === animatedHash) {
            _this.newBlockHash = null;
          }
        }, {
          once: true
        });
      }
      this.setupScrollListener();
    }
  }, {
    key: "setupScrollListener",
    value: function setupScrollListener() {
      var _this2 = this;
      this.cleanupScroll();
      this.scrollHandler = function () {
        if (_this2.loadingMore || !_this2.hasMore) return;
        var sentinel = document.querySelector('.explorer-load-more');
        if (!sentinel) return;
        var rect = sentinel.getBoundingClientRect();
        if (rect.top < window.innerHeight + 200) {
          _this2.loadMore();
        }
      };
      window.addEventListener('scroll', this.scrollHandler, {
        passive: true
      });
    }
  }, {
    key: "cleanupScroll",
    value: function cleanupScroll() {
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler);
        this.scrollHandler = null;
      }
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      this.loadToken++;
      this.cleanupScroll();
    }
  }, {
    key: "reload",
    value: function reload() {
      this.loadToken++;
      this.rawBlocks = [];
      this.loading = true;
      this.loadingMore = false;
      this.hasMore = true;
      this.error = null;
      this.newBlockHash = null;
      this.paint();
      this.loadInitial();
    }
  }, {
    key: "onNewBlock",
    value: function onNewBlock(block, longestChain) {
      if (!this.autoRefresh || !this.showForkBlocks && !longestChain || !block) {
        return;
      }
      var nextBlock = block;
      if (typeof block.toJson === 'function') {
        try {
          nextBlock = JSON.parse(block.toJson());
        } catch (err) {
          nextBlock = block;
        }
      }
      nextBlock = _objectSpread(_objectSpread({}, nextBlock), {}, {
        in_longest_chain: Boolean(longestChain)
      });
      if (nextBlock.has_golden_ticket == null) {
        try {
          nextBlock.has_golden_ticket = Boolean(block.hasGoldenTicket);
        } catch (err) {
          nextBlock.has_golden_ticket = false;
        }
      }
      var hash = String(nextBlock.hash || '');
      var currentLength = Math.max(this.rawBlocks.length, PAGE_SIZE);
      this.rawBlocks = this.rawBlocks.filter(function (entry) {
        return String((entry === null || entry === void 0 ? void 0 : entry.hash) || '') !== hash;
      });
      this.rawBlocks.unshift(nextBlock);
      this.rawBlocks = this.rawBlocks.slice(0, currentLength);
      this.newBlockHash = hash;
      this.loading = false;
      this.error = null;
      this.paint();
    }
  }, {
    key: "getSmallestBlockId",
    value: function getSmallestBlockId() {
      var smallest = Infinity;
      for (var i = 0; i < this.rawBlocks.length; i++) {
        var _this$rawBlocks$i;
        var id = Number((_this$rawBlocks$i = this.rawBlocks[i]) === null || _this$rawBlocks$i === void 0 ? void 0 : _this$rawBlocks$i.id);
        if (Number.isFinite(id) && id < smallest) {
          smallest = id;
        }
      }
      return Number.isFinite(smallest) ? smallest : null;
    }
  }, {
    key: "loadInitial",
    value: function loadInitial() {
      var _this3 = this;
      var peer = this.mod.explorerPeer;
      if (!peer) {
        this.loading = false;
        this.error = 'Waiting for Explorer peer connection.';
        this.paint();
        return;
      }
      var token = ++this.loadToken;
      sendExplorerPeerRequest(this.app, 'request blocks', {
        data: {
          request: 'request blocks',
          count: PAGE_SIZE,
          include_offchain: this.showForkBlocks
        },
        callback: function callback(response) {
          if (token !== _this3.loadToken) {
            return;
          }
          _this3.loading = false;
          if (response !== null && response !== void 0 && response.err || !(response !== null && response !== void 0 && response.success)) {
            _this3.error = (response === null || response === void 0 ? void 0 : response.error) || 'Failed to load blocks.';
            _this3.paint();
            return;
          }
          var data = Array.isArray(response.data) ? response.data : [];
          _this3.rawBlocks = data;
          _this3.hasMore = data.length >= PAGE_SIZE;
          _this3.paint();
        },
        peer: peer
      });
    }
  }, {
    key: "loadMore",
    value: function loadMore() {
      var _this4 = this;
      if (this.loadingMore || !this.hasMore) return;
      var peer = this.mod.explorerPeer;
      if (!peer) return;
      var beforeId = this.getSmallestBlockId();
      if (!beforeId || beforeId <= 1) {
        this.hasMore = false;
        this.paint();
        return;
      }
      this.loadingMore = true;
      this.paint();
      var token = this.loadToken;
      sendExplorerPeerRequest(this.app, 'request blocks', {
        data: {
          request: 'request blocks',
          count: PAGE_SIZE,
          include_offchain: this.showForkBlocks,
          before_id: beforeId
        },
        callback: function callback(response) {
          if (token !== _this4.loadToken) {
            return;
          }
          _this4.loadingMore = false;
          if (response !== null && response !== void 0 && response.err || !(response !== null && response !== void 0 && response.success)) {
            _this4.hasMore = false;
            _this4.paint();
            return;
          }
          var data = Array.isArray(response.data) ? response.data : [];
          if (data.length === 0) {
            _this4.hasMore = false;
          } else {
            _this4.rawBlocks = _this4.rawBlocks.concat(data);
            _this4.hasMore = data.length >= PAGE_SIZE;
          }
          _this4.paint();
        },
        peer: peer
      });
    }
  }]);
}();
module.exports = AllBlocks;